<template>
  <b-tabs v-model="tab" pills class="branded mb-4" content-class="mt-3">
    <template v-if="hasProductsTab" #tabs-start>
      <b-nav-item :href="`${iframeUrlPrefix}/org/${organization.id}/products`" role="presentation">
        {{ !!productsPage ? productsPage.name : trans('products') }}
      </b-nav-item>
    </template>
    <cart-tab
      v-if="!!invoice"
      :organization="organizationWithInjectedClient"
      :invoice="invoice"
      :show-close="false"
      hide-continue-shopping
      :button-title="trans('next')"
      :disabled="isFinalized || paymentFormBusy"
      @invoice="invoice = $event"
      @invoiceempty="onEmptyCart"
      @click="onNext"
    ></cart-tab>
    <b-tab
      v-if="!!invoice"
      :title="trans('your_information')"
      :disabled="isCartEmptyOrExpired || invoice.status != 'new' || isFinalized || paymentFormBusy"
    >
      <client-forms
        :organization="organizationWithInjectedClient"
        :invoice="invoice"
        :recipient="recipient"
        @next="onFormFilled"
        @previous="onPrevious"
        @invoice="invoice = $event"
        @client="client = $event"
      ></client-forms>
    </b-tab>
    <b-tab
      v-if="!!invoice"
      :title="trans('payment')"
      :disabled="!isFormFilled || isFinalized"
      lazy
    >
      <payment-form
        :organization="organizationWithInjectedClient"
        :invoice="invoice"
        :recipient="recipient"
        @next="onPaymentMade"
        @previous="onPrevious"
        @invoice="invoice = $event"
        @busy="paymentFormBusy = $event"
      ></payment-form>
    </b-tab>
    <b-tab v-if="!!invoice" :title="trans('confirmation')" :disabled="!isFinalized" lazy :active="isFinalized">
      <confirmation-card
        :organization="organizationWithInjectedClient"
        :invoice="invoice"
        :recipient="recipient"
      ></confirmation-card>
    </b-tab>
  </b-tabs>
</template>

<script>
  import CartTab from './CartTab'
  import ClientForms from './CheckoutClientForms'
  import PaymentForm from './CheckoutPaymentForm'
  import ConfirmationCard from './CheckoutConfirmation'

  export default {
    props: {
      organization: Object,
      productsPage: Object,
      hasConflicts: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      CartTab,
      ClientForms,
      PaymentForm,
      ConfirmationCard,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        iframeUrlPrefix: _.iframeUrlPrefix,
        busy: false,
        error: null,
        invoice: undefined,
        client: undefined,
        tab: 0,
        isFormFilled: false,
        isPaymentMade: false,
        paymentFormBusy: false,
      }
    },
    computed: {
      hasProductsTab() {
        return this.organization.has_stripe_terminal && !!this.organization.auth_user
      },
      isCartEmptyOrExpired() {
        return !this.invoice || this.invoice.invoice_items.length == 0
      },
      recipient() {
        if (!this.invoice) return null
        return this.invoice.recipient
      },
      isFinalized() {
        return !!this.invoice && !!this.invoice.finalized_at
      },
      organizationWithInjectedClient() {
        return this.client !== undefined ?
          _.assign({}, this.organization, {connected_client: this.client}) :
          this.organization
      },
    },
    methods: {
      onFormFilled() {
        if (this.hasConflicts) {
          _.toastError(this, trans('resolve_booking_conflicts_first'))
          return
        }
        this.isFormFilled = true
        this.$nextTick(() => {
          this.tab += 1
        })
      },
      onPaymentMade() {
        this.isPaymentMade = true
        this.$nextTick(() => {
          this.tab += 1
        })
      },      
      onNext() {
        if (this.hasConflicts) {
          _.toastError(this, trans('resolve_booking_conflicts_first'))
          return
        }
        if (this.isFinalized) {
          this.isFormFilled = true
          this.isPaymentMade = true
          this.$nextTick(() => {
            this.tab = 3
          })
          return
        }
        this.tab += 1
      },
      onPrevious() {
        this.tab -= 1
      },
      onEmptyCart() {
        this.$nextTick(() => {
          window.location.reload()
        })
      },
      loadCart() {
        this.busy = true
        this.error = null
        axios.post(`/org/${this.organization.id}/cart`)
        .then(response => {
          this.busy = false
          this.invoice = !_.isEmpty(response.data) ? response.data : null
          this.$nextTick(() => {
            if (!!this.invoice) this.tab = window.location.hash == '#form' ? 1 : 0
          })
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          _.toastError(this, this.error)
        })
      }
    },
    mounted() {
      window.checkoutTabs = this
      this.loadCart()
    },
  }
</script>
